





































import { Component, Vue } from "vue-property-decorator";
import { ButtonVariant } from "@/types";
import { createPartyPage } from "@/router";

@Component
export default class AboutPage extends Vue {
  $enums = {
    ButtonVariant,
  };

  version: string = process.env.VUE_APP_VERSION;
  gitHash: string = process.env.VUE_APP_GIT_HASH;

  onClick(): void {
    this.$router.push(createPartyPage());
  }
}
